import React, { CSSProperties } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import theme from '@/config/theme';

export interface TemplateOption {
    value: string | null;
    label: string;
}

interface Props {
    options: TemplateOption[];
    value: string | null;
    onChange: (v: string | null) => void;
    threshold?: number; // quantidade máxima de chips antes de mudar p/ select
}

export default function TemplatePickerWeb({ options, value, onChange, threshold = 5 }: Props) {
    if (options.length <= threshold) {
        return (
            <View style={styles.chipsContainer}>
                {options.map((opt, idx) => (
                    <TouchableOpacity
                        key={idx}
                        style={[styles.badge, value === opt.value && styles.badgeActive]}
                        onPress={() => onChange(opt.value)}
                    >
                        <Text style={styles.badgeText}>{opt.label}</Text>
                    </TouchableOpacity>
                ))}
            </View>
        );
    }

    // Mais templates: usar <select>
    const selectStyle: CSSProperties = {
        padding: 8,
        borderRadius: theme.borderRadius.md,
        borderWidth: 1,
        borderColor: theme.colors.border.light,
        width: '100%',
        backgroundColor: theme.colors.background.secondary,
        color: theme.colors.text.primary,
    } as any;

    return (
        <select
            style={selectStyle}
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value || null)}
        >
            {options.map((opt, idx) => (
                <option key={idx} value={opt.value ?? ''}>
                    {opt.label}
                </option>
            ))}
        </select>
    );
}

const styles = StyleSheet.create({
    chipsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: 8,
    },
    badge: {
        paddingHorizontal: 12,
        paddingVertical: 4,
        borderRadius: 12,
        backgroundColor: theme.colors.primary.default,
        marginRight: 8,
        marginTop: 4,
    },
    badgeActive: {
        backgroundColor: theme.colors.primary.dark,
    },
    badgeText: {
        color: '#fff',
    },
}); 